import axios from 'axios';
import {FilterDemand} from "../types/filterDemand";
import {DownloadResults} from '../types/downloadResults';

let publicationsEndpoint = '?ajaxDestination[identifier]=downloadItems';


const downloadsQueryParams: {[key: string] : any} = {
    tags: 'ajaxDestination[tag]',
    option1: 'ajaxDestination[option1]',
    option2: 'ajaxDestination[option2]',
    limit: 'ajaxDestination[limit]',
    term: 'ajaxDestination[term]'
};

export function getAllDownloads(demand: FilterDemand): Promise<DownloadResults> {
    return axios.get(getBaseUrl() + publicationsEndpoint + createQueryParamsFromDemand(demand))
        .then((response) => response.data);
}

export function getBaseUrl(): string {
    const rootElement: HTMLElement | null = document.querySelector('[data-internezzo-downloads-downloads-baseurl]');

    if (rootElement !== null && rootElement.dataset.hasOwnProperty('internezzoDownloadsDownloadsBaseurl') && rootElement.dataset.internezzoDownloadsDownloadsBaseurl) {
        return rootElement.dataset.internezzoDownloadsDownloadsBaseurl;
    }

    if (window.location.origin.includes('localhost')) {
        return 'https://swissbanking.ddev.site/de';
    }

    return '';
}

function createQueryParamsFromDemand(demand : FilterDemand) : string {
    let queryParams = '';

    const demandKeys = Object.keys(demand);
    const castDemand = demand as {[key: string] : any};

    demandKeys.forEach((key : string) => {
        const value = Array.isArray(castDemand[key]) ? castDemand[key].join() : castDemand[key];

        if (value) {
            queryParams += '&' + downloadsQueryParams[key] + '=' + value;
        }
    });

    /*TODO: MW: Q: do wee need this? same in publications*/
    //return queryParams.split('&').filter(Boolean).join('&');
    return queryParams;
}
